// Limitation.js


function Limitation() {
  return (
    <section id="technology" className="col-md-6 mb-4 text-center py-4 limitation-section" data-aos="fade-right" data-aos-delay="100">
      <h2 className="mb-3">Limitations of Existing Systems</h2>
      <i className="fas fa-exclamation-triangle fa-4x mb-5 icon"></i>
      <p className="w-500">
        Modern livestock tracking systems often use GSM or satellite networks, but these are costly, need lots of power, and aren’t practical for small farmers in developing countries. Studies have tested GPS collars with GSM networks, but they don’t work well in areas with poor coverage and are still too expensive for most farmers in Sri Lanka.
      </p>
    </section>
  );
}

export default Limitation;
